type SoftRange = {
	softMin?: number;
	softMax?: number;
};

export const isValueUnusual = (
	value: number,
	{ softMin, softMax }: SoftRange,
) =>
	(softMin !== undefined && value < softMin) ||
	(softMax !== undefined && value > softMax);
